var _defs, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLigaAppArena(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 495,
    cy: 975,
    rx: 131,
    ry: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st0",
    d: "M499.5,902.9c-79.6-152.5-268.6-195.8-351.1-350.8-90.9-170.8-34.9-309.7-15.4-367.2,19.1-56.2,50.3-113.9,92.7-171.4l9.9-13.4,12.6,11.2c12.3,11,26.6,20,42.3,26.7,17.5,7.5,35.5,12.5,53.4,14.9,3.7.5,7.4.8,11.1,1.1,3.8.3,7.6.4,11.4.4h7.7c21-.9,42.6-5.6,63.6-13.8,19.8-7.8,37.5-18,52.4-30.4l9.9-8.2,9.9,8.2c14.9,12.5,32.6,22.7,52.4,30.4,21,8.2,42.6,12.8,63.6,13.8h7.7c3.8,0,7.6-.1,11.4-.4,3.7-.2,7.4-.6,11.1-1.1,17.9-2.4,35.9-7.4,53.4-14.9,15.8-6.8,30-15.8,42.3-26.7L764.3,0l9.9,13.4c42.5,57.5,73.7,115.2,92.7,171.4,19.5,57.5,75.5,196.5-15.4,367.2-82.5,154.9-272.6,198.3-352.1,350.8ZM495,319.3c49.9,0,90.4-40.5,90.4-90.4s-40.5-90.4-90.4-90.4-90.4,40.5-90.4,90.4,40.5,90.4,90.4,90.4ZM613.4,391.8v-31.4h-236.9v31.4h42.9v227.6h-42.9v31.4h236.9v-31.4h-42.9v-227.6h42.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLigaAppArena);
export default __webpack_public_path__ + "static/media/LIGA_APP_arena.4c44a97aa2c8b9dc8072f00c4df561c1.svg";
export { ForwardRef as ReactComponent };